import React, { FC } from "react";
import { Setting } from "../App";
import { useSubscriptionLineEditVariant } from "../hooks/use-subscription-line-edit-variant";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";

export const SubscriptionLineEditVariant: FC<{ setting: Setting }> = ({
  setting,
}) => {
  const {
    subscription,
    productDetail,
    lineId,
    variant,
    quantity,
    onChangeVariant,
    onChangeQuantify,
    onSelectItem,
    onClickCompleteAction,
    isProc,
    detailPlanGroups
  } = useSubscriptionLineEditVariant(setting);

  if (!productDetail || !subscription || !variant) {
    return <></>;
  }

  const isAddProduct = lineId === 'add';
  const actionType = lineId === "new" ? "追加" : "変更";
  const title = isAddProduct ? '製品の追加' : '商品の' + actionType;
  const description = isAddProduct ? 'ご注文の製品を追加' : 'ご注文の商品を' + actionType;
  let modalContent = `以下の商品に${actionType}しました。`;

  if (isAddProduct) {
    modalContent = `以下の製品を追加しました。`;
  } else if (lineId === "new") {
    modalContent = `以下の商品を${actionType}しました。`;
  }

  const oldSubscriptionLine =
    subscription === undefined
      ? undefined
      : subscription.subscriptionLines.find(
          (line) => line.lineId === decodeURIComponent(lineId)
        );
  const oldQuantity =
    oldSubscriptionLine === undefined ? 1 : oldSubscriptionLine.quantity;

  let productImage = variant.image?.transformedSrc ? variant.image.transformedSrc : "";
  if (productDetail?.products?.length && productImage === "") {
    productImage = productDetail?.products[0].images[0].transformedSrc;
  }

  let productPrice = (Number(variant.price) * quantity);
  let actualProductPrice = productPrice;

  // Retrieve the discount value set in the 定期購買 app to calculate the product price
  if (detailPlanGroups && productDetail?.plans.length > 0) {
    const planFilteredObjects = detailPlanGroups.filter(item => item.plans.some(plan => plan.planId === productDetail.plans[0].planId));
    if (planFilteredObjects.length > 0) {
      const foundPlanObject = planFilteredObjects[0].plans.find(plan => plan.planId === productDetail.plans[0].planId);

      if (foundPlanObject?.pricingPolicyAdjustmentType === 'PERCENTAGE' && foundPlanObject?.pricingPolicyAdjustmentValue && foundPlanObject?.pricingPolicyAdjustmentValue > 0) {
        const discount = foundPlanObject.pricingPolicyAdjustmentValue / 100;
        actualProductPrice = Number(Math.round(productPrice - (productPrice * discount)));
      }
    }
  }

  return (
    <>
      <h2>{title}</h2>
      <p>
        次回、{description}します。下記の商品から選択してください。
      </p>
      {isAddProduct && <p className="add-more-product-note">※お申込製品のお届けサイクルと同じ場合のみ製品を追加いただます。 異なるお届けサイクルでは、追加できません。 その場合は、新たにお申込みください。</p>}

      <div className="huckleberry-subscription-product-edit variant">
        {productDetail!.products!.map((product) => {
          return (
            <div className="item" key={product.productId}>
              <figure>
                <img
                  src={productImage}
                  alt=""
                />
              </figure>
              <div className="column-right">
                <p className="title">{product.title}</p>
                <label className="variant">
                  <select value={variant!.id} onChange={onChangeVariant}>
                    {product.variants.map((variant) => {
                      return (
                        <option value={variant.id} key={variant.id}>
                          {variant.displayName}
                        </option>
                      );
                    })}
                  </select>
                </label>
                <label className="quantity">
                  <span className="prefix">個数</span>
                  {lineId === "new" || subscription.shop.showChangeQuantity ? (
                    <input
                      type="number"
                      min="1"
                      value={quantity}
                      onChange={onChangeQuantify}
                    />
                  ) : (
                    <>
                      {oldQuantity}
                      <input
                        type="hidden"
                        min="1"
                        value={oldQuantity}
                        onChange={onChangeQuantify}
                      />
                    </>
                  )}
                </label>
                <NumberFormat
                  className="price"
                  displayType="text"
                  value={actualProductPrice}
                  thousandSeparator={true}
                  prefix="金額&nbsp;"
                  suffix="&nbsp;円（税込み）"
                />
                <div className="btn-group">
                  <button
                    className="select"
                    onClick={onSelectItem}
                    disabled={isProc}
                  >
                    決定
                  </button>
                  <Link
                    className="back"
                    to={`/subscriptions/${encodeURIComponent(
                      subscription!.subscriptionContractId
                    )}/lines/${encodeURIComponent(lineId)}`}
                  >
                    再選択
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="micromodal" id="modal-complete" aria-hidden="true">
        <div className="micromodal-overlay" tabIndex={-1}>
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-complete-title"
          >
            <header>
              <button aria-label="Close modal" data-micromodal-close></button>
              <h2 id="modal-complete-title">{title}</h2>
            </header>
            <main id="modal-complete-content">
              <p>
                <>{modalContent}</>
                <br />
                次回のご注文から変更されます。
                <br />
                <br />
                商品：{productDetail ? productDetail!.products![0].title : ""}
                <br />
                {variant ? variant!.title.replace("Default Title", "") : ""}
              </p>
            </main>
            <footer>
              <button className="btn" onClick={onClickCompleteAction}>
                ＯＫ
              </button>
            </footer>
          </div>
        </div>
      </div>
      <div className="micromodal" id="modal-stock-error" aria-hidden="true">
        <div className="micromodal-overlay" tabIndex={-1}>
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-stock-error-title"
          >
            <header>
              <button aria-label="Close modal" data-micromodal-close></button>
              <h2 id="modal-stock-error-title">{title}</h2>
            </header>
            <main id="modal-stock-error-content">
              <p>
                在庫がありません。
                <br />
                入荷をお待ちいただくか、他の商品に変更をお願いします。
              </p>
            </main>
            <footer>
              <button className="btn" data-micromodal-close>
                ＯＫ
              </button>
            </footer>
          </div>
        </div>
      </div>
      <div className="micromodal" id="modal-error" aria-hidden="true">
        <div className="micromodal-overlay" tabIndex={-1}>
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-error-title"
          >
            <header>
              <button aria-label="Close modal" data-micromodal-close></button>
              <h2 id="modal-error-title">エラー</h2>
            </header>
            <main id="modal-error-content">
              <p>エラーが発生しました・カスタマーサポートへお問合せください。</p>
            </main>
            <footer>
              <button className="btn" data-micromodal-close>
                ＯＫ
              </button>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
};
